module.exports = __webpack_public_path__ + "img/SHIELD.1e49c1f2.svg";